var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 25,
    viewBox: "0 0 13 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.085 14.416L12.7515 10.0726H8.58387V7.25398C8.58387 6.0657 9.16605 4.90742 11.0326 4.90742H12.9273V1.20945C12.9273 1.20945 11.2079 0.916016 9.56402 0.916016C6.13184 0.916016 3.8884 2.99633 3.8884 6.76227V10.0726H0.0732422V14.416H3.8884V24.916H8.58387V14.416H12.085Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.375ab40a9456f8d3dde93de8db7ea9a7.svg";
export { ForwardRef as ReactComponent };